import { Box } from "@chakra-ui/react";
import PlayingCard from "./PlayingCard";

export default function KellyansCards({ gameState }) {
  const { kellyanDownCards, kellyanCardVisiblity } = gameState;

  // handle case where kellyan only has one card
  if (kellyanDownCards.length === 1) {
    return (
      <Box transform="rotate(-10deg) ">
        <PlayingCard
          rank={kellyanDownCards[0].rank}
          suit={kellyanDownCards[0].suit}
          isVisible={kellyanCardVisiblity[0]}
        />
      </Box>
    );
  } else if (kellyanDownCards.length > 1) {
    return (
      <Box position="relative">
        <Box transform="rotate(-10deg) translateY(-30px)">
          <PlayingCard
            rank={kellyanDownCards[0].rank}
            suit={kellyanDownCards[0].suit}
            isVisible={kellyanCardVisiblity[0]}
          />
        </Box>
        {/* first down card */}
        {kellyanDownCards[1] && (
          <Box position="absolute" top="40px" left="-40px">
            <PlayingCard
              rank={kellyanDownCards[1].rank}
              suit={kellyanDownCards[1].suit}
              isVisible={kellyanCardVisiblity[1]}
            />
          </Box>
        )}
        {/* second down card */}
        {kellyanDownCards[2] && (
          <Box position="absolute" top="30px" left="0px">
            <PlayingCard
              rank={kellyanDownCards[2].rank}
              suit={kellyanDownCards[2].suit}
              isVisible={kellyanCardVisiblity[2]}
            />
          </Box>
        )}
        {/* third down card */}
        {kellyanDownCards[3] && (
          <Box position="absolute" top="20px" left="40px">
            <PlayingCard
              rank={kellyanDownCards[3].rank}
              suit={kellyanDownCards[3].suit}
              isVisible={kellyanCardVisiblity[3]}
            />
          </Box>
        )}
        {/* fourth down card (to flip) */}
        {kellyanDownCards[4] && (
          <Box position="absolute" top="10px" left="80px">
            <PlayingCard
              rank={kellyanDownCards[4].rank}
              suit={kellyanDownCards[4].suit}
              isVisible={kellyanCardVisiblity[4]}
            />
          </Box>
        )}
      </Box>
    );
  }
}
